import { MDBBtn, MDBCardLink, MDBCol, MDBCollapse, MDBContainer, MDBIcon, MDBInput, MDBRow, MDBTable, MDBTableBody, MDBTableHead, MDBTabsPane } from 'mdb-react-ui-kit';
import React, { useState } from 'react';
import PositionsSelector from './PositionsSelector';
import ListsSelector from './ListSelector';
import FavoritesBillsDetails from './FavoritesBillsDetails';

const FavoritesBillsBody = ({active}) => {
    const [expandedRow, setExpandedRow] = useState(null);

    const toggleRow = (rowId) => {
        setExpandedRow(expandedRow === rowId ? null : rowId);
    };

    const rows = [
        { 
            id: 1, 
            bill: "HB 01", 
            lc: "LC0001", 
            shortTitle: "Feed Bill to funf 68th legislative session montana", 
            status: "Stauts",
            actions:  <MDBIcon className='notitification-list-delete-btn' fas icon="trash" />,
            expandedBody: <FavoritesBillsDetails />
        }            
    ];

    return (
        <MDBTabsPane show={active}>
            <MDBContainer fluid>
                <div>
                    <MDBRow className="ms-auto" style={{ maxWidth: '50%' }}>
                        <MDBCol className='p-0 m-1'>
                            <PositionsSelector />
                        </MDBCol>
                        <MDBCol className='p-0 m-1'>
                            <ListsSelector />
                        </MDBCol>
                        <MDBCol className='p-0 m-1'>
                            <MDBInput
                                label="Search"
                                id="billSearchFav"
                                type="text"
                            />
                        </MDBCol>
                    </MDBRow>
                </div>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                            <th></th>
                            <th>Bill #</th>
                            <th>LC #</th>
                            <th>Short Title</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        {rows.map((row) => (
                            <React.Fragment key={row.id}>
                                <tr>
                                    <td style={{ width: "max-content" }}>
                                        <MDBCardLink size='sm' color='link' onClick={() => toggleRow(row.id)}>
                                            {expandedRow === row.id ? <i className="fas fa-angle-up"></i> : <i className="fas fa-angle-down"></i>}
                                        </MDBCardLink>
                                    </td>
                                    <td>{row.bill}</td>
                                    <td>{row.lc}</td>
                                    <td>{row.shortTitle}</td>
                                    <td>{row.status}</td>
                                    <td>{row.actions}</td>
                                </tr>
                                <tr>
                                    <td colSpan="6" style={{ padding: 0 }}>
                                        <MDBCollapse show={expandedRow === row.id}>
                                            <div className="p-3 bg-light">
                                                <h5>{row.name}</h5>
                                                <div>{row.expandedBody}</div>
                                            </div>
                                        </MDBCollapse>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </MDBTableBody>
                </MDBTable>
            </MDBContainer>
        </MDBTabsPane>
    );
}

export default FavoritesBillsBody;